import React, { useState, useEffect } from "react";
// Msal imports
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import {
  InteractionStatus,
  InteractionType,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { loginRequest } from "../authConfig.js";

// Sample app imports
import { ShipmentProcessDataGrid } from "../components/SalesOrder/ShipmentProcessDataGrid";
import { Loading } from "../components/Loading.jsx";
import { ErrorComponent } from "../components/ErrorComponent.jsx";
import { api_path } from "../shared";

export function ShipmentProcess() {
  const authRequest = {
    ...loginRequest,
  };
  const [getUserRole, setUserRole] = useState();
  const [getUserID, setUserID] = useState();
  const { accounts } = useMsal();
  useEffect(() => {
    fetchUserRole(accounts[0]?.username);
   
  });
  function fetchUserRole(userEmail) {
    fetch(api_path + "/USER_ROLE.php?USER_EMAIL=" + userEmail)
      .then((res) => res.json())
      .then((res) => {
        const array = res;
        for (const i of array) {
          setUserRole(i.USER_ROLE_ID);
          setUserID(i.CRM_UID);
        }
      });
  }
  const ShipmentProcessContent = () => {
    return <ShipmentProcessDataGrid 
    USER_ID={getUserID}
    USER_ROLE={getUserRole}
    />;
  };
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <ShipmentProcessContent />
    </MsalAuthenticationTemplate>
  );
}
